import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccountService } from 'src/app/services/modelService/account.service';
import { CommitteeService } from 'src/app/services/modelService/committee.service';

@Component({
  selector: 'app-payment-edit',
  templateUrl: './payment-edit.component.html',
  styleUrls: ['./payment-edit.component.scss'],
})
export class PaymentEditComponent implements OnInit {
  @Output() closePopup: EventEmitter<any> = new EventEmitter()
  constructor(public acs: AccountService, public cs: CommitteeService) { }

  ngOnInit() {
    this.cs.getMemberList([["committee_id", this.cs.committee.id]]);
  }

  clickClose() {
    this.closePopup.emit();
  }

  savePayment() {

    if (this.cs.myMemberShip.role != 'Treasurer' && this.acs.payment.status == null) {
      this.acs.payment.status = 'Committed'
    }
    if (this.cs.myMemberShip.role != 'Treasurer' && this.acs.payment.donor_id == null) {
      this.acs.payment.donor_id = this.cs.myMemberShip.id;
    }

    if (this.cs.myMemberShip.role == 'Treasurer' && this.acs.payment.receiver_id == null) {
      this.acs.payment.receiver_id = this.cs.myMemberShip.id;
    }

    if (this.acs.payment.donor_id != null) {
      let found = this.cs.memberList.find(x => x.id == this.acs.payment.donor_id);
      if (found) {
        this.acs.payment.donor_meta = found.profile_meta;
      }else{
        this.acs.payment.donor_meta = {
          name: this.acs.payment.donor_id
        };
      }
    }

    this.acs.savePayment().then(() => {
      this.acs.doCalculation();
      this.closePopup.emit();
    });
  }
}
